// extracted by mini-css-extract-plugin
export default {"base":"BaseLayout_base__yiwlA"};